import { blogSeoMetadata } from '../data/blogSeoMetadata';

export const publicPagePaths = [
  '/', '/start', '/companion-app', '/llm-info',
  '/platform/biomarker-informed-nutrition', '/personalised-nutrition-platform',
  '/nutrition-software-comparison',
  '/terms', '/platform-terms', '/privacy', '/platform-privacy', '/cookies',
  '/refund-cancellation-policy',
  '/founding-circle-agreement', '/data-processing-agreement', '/practitioner-declaration-consent',
];
export const marketingPaths = [...publicPagePaths, ...blogSeoMetadata.map(post => post.href)];
export const isMarketingPath = (pathname: string) => marketingPaths.includes(pathname);
